import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from '../../../../../components/Modal/ModalWrapper';
import PropTypes from 'prop-types';
import MundialButton from '../MundialButton/MundialButton';
import MatchDetailHeader from '../MatchDetailHeader/MatchDetailHeader';
import MatchDetailTabs from '../MatchDetailTabs/MatchDetailTabs';
import MatchDetailBody from '../MatchDetailBody/MatchDetailBody';
import MatchDetailStats from '../MatchDetailStats/MatchDetailStats';
import MatchDetailPlayers from '../MatchDetailPlayers/MatchDetailPlayers';
import MatchDetailSummary from '../MatchDetailSummary/MatchDetailSummary';
import MatchDetailLineups from '../MatchDetailLineups/MatchDetailLineups';
import MatchDetailVideoPanel from '../MatchDetailVideoPanel/MatchDetailVideoPanel';
import MatchDetailUpsellPanel from '../MatchDetailUpsellPanel/MatchDetailUpsellPanel';
import MatchDetailHeaderEmpty from '../MatchDetailHeaderEmpty/MatchDetailHeaderEmpty';
import MatchDetailHeaderGeneral from '../MatchDetailHeaderGeneral/MatchDetailHeaderGeneral';
import Utils, {showSpinner} from '../../../../../utils/Utils.js'
import { getMatchesStatistics } from '../../../services/getMatchesStatistics';
import matchesTask from '../../../../../requests/tasks/sports/matchesTask.js';
import { getPlayBackData } from '../../../services/getPlayBack';
import { getLiveMatchActions } from '../../../services/getLiveMatchActions';
import { CANCHA_ICONS } from '../../mock/matchDetailLineupsData';
import Metadata from '../../../../../requests/apa/Metadata';
import DeviceStorage from '../../../../../components/DeviceStorage/DeviceStorage';
import Translations from '../../../../../requests/apa/Translator';
import {GA4} from '../../../../../../src/utils/trackers/GA4';
import Assets from '../../../../../requests/apa/Asset';
import { buildStatsData, buildPlayersData, buildSummaryData, buildLineupsData, buildHeaderMatchData, getSportsLiveFeedMiniPlayerConfig, sendMetricContentPlay, mapLiveMatchActionPayload } from '../../../../../containers/Mundial2026/utils';
import { MINIPLAYER_RETRY_CONFIG_DEFAULT, MINIPLAYER_RETRY_CONFIG, MINIPLAYER_PLAYBACK_CONFIG, MINIPLAYER_PLAYBACK_CONFIG_DEFAULT, V1PLAYBACKCONFIG, V2PLAYBACKCONFIG, V3PLAYBACKCONFIG } from '../../../constants';
import './_MatchDetailModal.scss';
import LiveEventsTask from '../../../../../requests/tasks/sports/liveEventsTask.js'
import PlayerTimeWindowTask from '../../../../../requests/tasks/sports/playerTimeWindowsTask.js'
import RequestManager from '../../../../../requests/RequestManager.js';

/**
 * Normaliza una fecha de formato ISO 8601 a formato "YYYY-MM-DD HH:mm:ss"
 * Soporta:
 * - "2026-06-01T18:48:15.484-06:00" -> "2026-06-01 18:48:15"
 * - "2026-06-11T19:00:00Z" -> "2026-06-11 19:00:00"
 * - "2026-03-31 13:00:00" -> "2026-03-31 13:00:00" (sin cambios)
 * 
 * @param {string} dateString - Fecha en cualquier formato
 * @returns {string} Fecha en formato "YYYY-MM-DD HH:mm:ss"
 */
const normalizeDateToOldFormat = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return dateString;
  
  // Si ya está en formato antiguo, retornar sin cambios
  if (dateString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
    return dateString;
  }
  
  // Si es formato ISO 8601 (contiene 'T')
  if (dateString.includes('T')) {
    try {
      const date = new Date(dateString);
      
      // Extraer componentes en hora local
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
      console.error('Error normalizando fecha:', dateString, error);
      return dateString;
    }
  }
  
  // Si no es ninguno de los formatos conocidos, retornar sin cambios
  return dateString;
};

/**
 * Normaliza las fechas en los eventos de los canales de playback
 * @param {Object} playBackData - Datos de playback con canales y eventos
 * @returns {Object} Datos de playback con fechas normalizadas
 */
const normalizePlaybackDates = (playBackData) => {
  if (!playBackData || !playBackData.channels) return playBackData;
  
  const normalizedData = { ...playBackData };
  
  normalizedData.channels = playBackData.channels.map(channel => {
    if (!channel || !channel.events) return channel;
    
    return {
      ...channel,
      events: channel.events.map(event => {
        if (!event) return event;
        
        return {
          ...event,
          dateBegin: event.dateBegin ? normalizeDateToOldFormat(event.dateBegin) : event.dateBegin,
          dateEnd: event.dateEnd ? normalizeDateToOldFormat(event.dateEnd) : event.dateEnd
        };
      })
    };
  });
  
  return normalizedData;
};

/**
 * 
 * MatchDetailModal
 * 
 * Modal que muestra detalles completos de un partido de fútbol:
 * - Tarjeta de marcador con equipos
 * - Navegación por tabs (Estadísticas, Jugadores, Resumen, Alineaciones)
 * - Contenido dinámico según tab activo
 * - Comparativas de estadísticas de partido
 */

class MatchDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'stats',
      matchStats: null, // Para el view 'all'. Primer llamado, después empieza polling. Se usa tanto para llenar las Estadísticas como para la data que se muestra en el header de la modal.
      matchStatsWithPolling: null, // Para el polling con el view de 'team-statistics'.
      headerMatchDataWithPolling: null, // Para almacenar la data del header que se actualiza con el polling de 'team-statistics'
      reproductionAlarms: {},
      hasSuccessfulPlayerPolling: false,
      hasOperationHasReproductionPermission: false,
      showVideoPanel: false,
      payloadGroupId: false,
      showUpsellOverlay: false,
      selectedChannelForUpsell: null,
      liveMatchActions: [], // Acciones en vivo del partido
      isLoadingActions: false,
      lineupsWithPolling: null, // Para el polling con el view de 'lineups'.
      matchIsPlaying: false
    };
    const code = this.getNodeCode()
    const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null);
    this.leagueId = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null;
    this.matchId = props.matchData && props.matchData.matchId ? props.matchData.matchId : null;
    this.miniplayerRetryConfig = this.getMiniplayerRetryConfigAndPlayerPlaybackConfig(MINIPLAYER_RETRY_CONFIG, MINIPLAYER_RETRY_CONFIG_DEFAULT);
    this.miniPlayerPlaybackConfig = this.getMiniplayerRetryConfigAndPlayerPlaybackConfig(MINIPLAYER_PLAYBACK_CONFIG, MINIPLAYER_PLAYBACK_CONFIG_DEFAULT);
    this.isPlayBackConfigEnable = this.miniPlayerPlaybackConfig && this.miniPlayerPlaybackConfig.play_comments ? true : false;
    const playLiveMatchConfig = this.miniPlayerPlaybackConfig && this.miniPlayerPlaybackConfig.play_live_match;
    // Leer la versión desde play_live_match.version en cualquier caso (play_comments o play_live_match)
    this.versionPlayBackConfig = (playLiveMatchConfig && playLiveMatchConfig.version) || V1PLAYBACKCONFIG;
    this.enabledPlayBackConfig = playLiveMatchConfig ? !!playLiveMatchConfig.enable : false;
    this.scheduledAt = null;
    this.classifiedData = null;
    this.vigenteEventObject = null;
    this.upsellClosedBySchedule = false;
    this.upsellTimerId = null;
    this.pollingConfig = getSportsLiveFeedMiniPlayerConfig();
    this.isPollingEnabled = this.pollingConfig && this.pollingConfig.enabled;
    this.pollers = {};
    this.intervalHeader = null;
    this.actionIdSet = new Set(); // Set para deduplicaci\u00f3n de acciones
    this.currentNodeCode = this.getNodeCode(); // Nodo actual para detecci\u00f3n de navegaci\u00f3n
    this.interval = null;
    this.eventKey = null;
    this.matchGroupId = null;
    this.reproductionAlarms = {}
  }

  getMiniplayerRetryConfigAndPlayerPlaybackConfig(key, defaultValue) {
      let metadataKey = Metadata.get(key, defaultValue);
      metadataKey = JSON.parse(metadataKey)
      const region = DeviceStorage.getItem('region');
      return metadataKey[region] || metadataKey['default'];
  }

  async componentDidMount() {
    if (this.leagueId && this.matchId) {
      let matchIsPlaying = false
      let currentDate = Utils.nowWithTimezoneOffset();
      currentDate = Math.floor(currentDate.getTime() / 1000)

     
      const matchStats = await getMatchesStatistics(this.leagueId, this.matchId)

      const headerMatchData = buildHeaderMatchData(matchStats)
      const matchStatus = headerMatchData && headerMatchData.status ? headerMatchData.status : ''
      this.initialMatchStatus = matchStatus;
      
      this.scheduledAt = matchStats && matchStats.matchCard && matchStats.matchCard[0] && matchStats.matchCard[0].summary && matchStats.matchCard[0].summary.scheduledAt ? matchStats.matchCard[0].summary.scheduledAt : null;


      const hasOperationHasReproductionPermission = 
        matchStats && 
        matchStats.matchCard &&
        matchStats.matchCard[0].summary &&
        matchStats.matchCard[0].summary.broadcast && 
        matchStats.matchCard[0].summary.broadcast.isAvailable && (matchStatus === 'IN_PROGRESS' || matchStatus === 'SCHEDULED') ? true : false; //Operación con derecho a reproducción

      const matchGroupId = 
        matchStats && 
        matchStats.matchCard &&
        matchStats.matchCard[0].summary &&
        matchStats.matchCard[0].summary.broadcast && 
        matchStats.matchCard[0].summary.broadcast.groupId

      this.matchGroupId = matchGroupId || null;

      const scheduledAtUnix = this.scheduledAt
        ? Math.floor(new Date(this.scheduledAt.replace('Z', '').replace('T', ' ')).getTime() / 1000)
        : null;

      let showVideoPanel = false

      if(hasOperationHasReproductionPermission && this.enabledPlayBackConfig)  showVideoPanel = true
      
      if(currentDate >= scheduledAtUnix ){
        matchIsPlaying = true;
      }else if(hasOperationHasReproductionPermission && this.enabledPlayBackConfig){
        this.intervalMatch = setInterval(async () => {
          const scheduledAtUnix = this.scheduledAt
          ? Math.floor(new Date(this.scheduledAt.replace('Z', '').replace('T', ' ')).getTime() / 1000)
          : null;
          let currentDate = Utils.nowWithTimezoneOffset();
          currentDate = Math.floor(currentDate.getTime() / 1000)
          console.log('oscar tiempo restante para el partido', scheduledAtUnix - currentDate)

          if((scheduledAtUnix - currentDate) === 0) {  
            matchIsPlaying = true;
            let playBackData = await getPlayBackData(this.leagueId, this.matchId, this.miniplayerRetryConfig, this.versionPlayBackConfig, false, matchGroupId)
            // Normalizar las fechas de playback al formato antiguo
            playBackData = normalizePlaybackDates(playBackData);
            console.log('oscar playBackData después de normalizar las fechas:', playBackData);
            this.setState({ matchStats, playBackData, hasOperationHasReproductionPermission, showVideoPanel: showVideoPanel && matchIsPlaying, matchIsPlaying});
            clearInterval(this.intervalMatch);
            if (this.interval) clearInterval(this.interval);
            if (this.reproductionAlarms && this.eventKey) delete this.reproductionAlarms[this.eventKey];
          }else if(scheduledAtUnix - currentDate < 0){
            // El scheduledAt ya pasó (tick se perdió el segundo exacto): llamar a playback
            // igual que en el caso === 0 para asegurar la transición correcta al estado EN VIVO.
            matchIsPlaying = true;
            clearInterval(this.intervalMatch);
            if (this.interval) clearInterval(this.interval);
            if (this.reproductionAlarms && this.eventKey) delete this.reproductionAlarms[this.eventKey];
            let playBackData = await getPlayBackData(this.leagueId, this.matchId, this.miniplayerRetryConfig, this.versionPlayBackConfig, false, matchGroupId)
            playBackData = normalizePlaybackDates(playBackData);
            console.log('oscar playBackData (< 0 branch) después de normalizar las fechas:', playBackData);
            this.setState({ matchStats, playBackData, hasOperationHasReproductionPermission, showVideoPanel: showVideoPanel && matchIsPlaying, matchIsPlaying });
          }
        }, 1000)
      } else if (this.isPlayBackConfigEnable && !hasOperationHasReproductionPermission && scheduledAtUnix && currentDate < scheduledAtUnix) {
        // Timer para apagar el PIP de play_comments cuando inicia el partido (sin broadcast ni play_live)
        this.intervalMatchComments = setInterval(() => {
          let nowUnix = Math.floor(Utils.nowWithTimezoneOffset().getTime() / 1000);
          if (nowUnix >= scheduledAtUnix) {
            this.setState({ matchIsPlaying: true, showVideoPanel: false });
            clearInterval(this.intervalMatchComments);
          }
        }, 1000);
      }
      // }

      let playBackData = null;
      const isLivePlaybackCall = hasOperationHasReproductionPermission && this.enabledPlayBackConfig;
      const isCommentsPlaybackCall = this.isPlayBackConfigEnable && (matchStatus === 'SCHEDULED' || matchStatus === 'COMPLETED' || matchStatus === 'FINISHED');
      if (isLivePlaybackCall || isCommentsPlaybackCall) {
        // Para el stream en vivo (IN_PROGRESS) no se envía play_comments; solo se envía en SCHEDULED/COMPLETED/FINISHED
        const playCommentsFlag = isCommentsPlaybackCall ? this.isPlayBackConfigEnable : false;
        playBackData = await getPlayBackData(this.leagueId, this.matchId, this.miniplayerRetryConfig, this.versionPlayBackConfig, playCommentsFlag, matchGroupId);
        // Normalizar las fechas de playback al formato antiguo
        if (playBackData) playBackData = normalizePlaybackDates(playBackData);
      }

      console.log('oscar playBackData después de normalizar las fechas:', playBackData);

      this.setState({ matchStats, playBackData, hasOperationHasReproductionPermission, showVideoPanel: showVideoPanel && matchIsPlaying, matchIsPlaying }, () => {
        // Si cumple las condiciones inicia el polling
        if (this.isPollingEnabled && this.matchId && (matchStatus === 'IN_PROGRESS' || matchStatus === 'SCHEDULED')) {
          this.startManagedPoller(`player-${this.matchId}`, this.matchId, matchStatus)
          this.startManagedPoller(`stats-${this.matchId}`, this.matchId, matchStatus)
          this.startManagedPoller(`live-actions-${this.matchId}`, this.matchId, matchStatus)
          this.startManagedPoller(`lineups-${this.matchId}`, this.matchId, matchStatus)
        }
      });

      const { matchData } = this.props
      const { path, match } = matchData
      const playEnabled = path && match && (matchStatus === 'IN_PROGRESS' || matchStatus === 'SCHEDULED') && hasOperationHasReproductionPermission
      if (playEnabled) {
        sendMetricContentPlay(path.mainMenuLabel, path.parentTabLabel, path.childTabLabel, match)
      }
      showSpinner(false);
    }
     // Monitorear navegación para detener polling al salir de Mundial 2026
    this.setupNavigationListener();
  }

  setupNavigationListener = () => {
    this.navigationCheckInterval = setInterval(() => {
      const currentCode = this.getNodeCode();
    // Si el nodo cambió, detener polling de live-actions     
      if (currentCode !== this.currentNodeCode) {
         console.log("::::/Cambio de navegación detectado, deteniendo polling de live-actions");
        this.stopManagedPoller(`live-actions-${this.matchId}`);
        this.currentNodeCode = currentCode;
      }
    }, 1000); // Revisar cada segundo
  }

  startManagedPoller = (pollerKey, matchId, matchStatus) => {
    console.log("::::/Inicia managed poller", pollerKey)
    if (!pollerKey) return
    this.stopManagedPoller(pollerKey)
    const stopFn = this.startPoller(matchId, matchStatus, pollerKey)
    if (typeof stopFn === 'function') {
      this.pollers[pollerKey] = stopFn
    }
  }

  stopManagedPoller = (pollerKey) => {
    console.log("::::/Finaliza managed poller", pollerKey)
    if (!pollerKey) return
    const stopFn = this.pollers[pollerKey]
    if (typeof stopFn === 'function') {
      stopFn()
    }
    delete this.pollers[pollerKey]
  }

  stopAllPollers = () => {
    Object.keys(this.pollers).forEach((pollerKey) => {
      this.stopManagedPoller(pollerKey)
    })
  }

  isTerminalMatchStatus = (status) => {
    return status === 'FINISHED' || status === 'COMPLETED'
  }

  getIntervalByMatchStatus = (matchStatus) => {
    const interval = 
      this.pollingConfig && 
      this.pollingConfig.polling && 
      this.pollingConfig.polling.intervalsByMatchStatus && 
      this.pollingConfig.polling.intervalsByMatchStatus[matchStatus]
    return interval ? interval : 60000
  }

  startPoller(matchId, matchStatus, pollerKey = null) {
    console.log("::::/Inicia el polling", pollerKey)
    if (!matchId) return null

    // Variables genéricas
    const defaultDelay = this.getIntervalByMatchStatus(matchStatus)
    let timeoutId = null
    let stopped = false

    // Variables de score
    const topics = ['SCORE','TIMELINE','LINEUPS']
    const limit = 100
    let lastEventId = null
    let nextPollMs = defaultDelay
    
    const poll = async () => {
      console.log("::::/Polling...", pollerKey)
      if (stopped) return

      try {
        let task = null;
        let response = null;
        
        // Flujo especial para live-actions
        if (pollerKey && pollerKey.includes('live-actions')) {
            if (!this.state.isLoadingActions && this.state.liveMatchActions.length === 0) {
             this.setState({ isLoadingActions: true });
           }
          const actionsResponse = await getLiveMatchActions(matchId, { 
            lastEventId: lastEventId,
            limit: 100 
          });
          
          if (actionsResponse && actionsResponse.events) {
            // Obtener matchData para el mapeo
            const currentMatchData = this.buildHeaderMatchData();
            
            // Mapear y filtrar acciones nuevas
            const mappedActions = actionsResponse.events
              .reverse()
              .map(action => mapLiveMatchActionPayload(action, currentMatchData))
              .filter(action => {
                if (action && action.type === 'SUBSTITUTION_IN') {
                  return false;
                }
                if (!action || !action.id || this.actionIdSet.has(action.id)) {
                  return false; // Filtrar duplicados y acciones inválidas
                }
                this.actionIdSet.add(action.id);
                return true;
              });

            const nextLastEventId = actionsResponse.lastEventId != null ? actionsResponse.lastEventId : lastEventId;

            if (mappedActions.length > 0) {
              this.setState(prevState => ({
                liveMatchActions: [...mappedActions, ...prevState.liveMatchActions].slice(0, 200),
                isLoadingActions: false
              }));
            } else {
               this.setState({ isLoadingActions: false });
            }

            if (actionsResponse.lastEventId !== undefined && actionsResponse.lastEventId !== null) {
              lastEventId = String(actionsResponse.lastEventId);
            } 

            // Determinar siguiente intervalo
            const hasMore = !!actionsResponse.hasMore;
            const nextPoll = Number.isFinite(actionsResponse.nextPollMs) && actionsResponse.nextPollMs >= 0
              ? actionsResponse.nextPollMs
              : defaultDelay;
            const delay = hasMore ? 0 : nextPoll;
            
            if (stopped) return;
            timeoutId = setTimeout(poll, delay);
          } else {
            if (stopped) return;
            timeoutId = setTimeout(poll, defaultDelay);
          }

          const matchStatus = actionsResponse && actionsResponse.matchStatus ? actionsResponse.matchStatus : '';
          if (this.isTerminalMatchStatus(matchStatus)) {
            console.log("::::/Termina el polling (finalización del partido)")
            // Actualizar el header con el estado terminal para que MatchDetailHeader cambie su layout
            // hasOperationHasReproductionPermission=false para que el live layout se oculte
            const currentHeaderData = this.state.headerMatchDataWithPolling || this.buildHeaderMatchData();
            const newState = { hasOperationHasReproductionPermission: false };
            if (currentHeaderData) {
              newState.headerMatchDataWithPolling = { ...currentHeaderData, status: matchStatus };
            }
            this.setState(newState);
            stopped = true
            clearTimeout(timeoutId)
            this.stopAllPollers()
            return
          }

          return;
        }
        
        switch (true) {
          case pollerKey.includes('lineups'): 
            task = new matchesTask(this.leagueId, this.matchId, 'lineups')
            break;
          case pollerKey.includes('player'): 
            task = new PlayerTimeWindowTask()
            break;
          case pollerKey.includes('stats'): 
            task = new matchesTask(this.leagueId, this.matchId, 'team-statistics')
            break;
          default:
            break;
        }

        response = task ? await RequestManager.addRequest(task) : null;

        // No hay respuesta del servicio
        if (!response) {
          if (stopped) return
          timeoutId = setTimeout(poll, defaultDelay)
          return
        }

        // Flujo player-time-windows
        const playerTimeWindowsEvents = response && response.events ? response.events : []
        if (pollerKey && pollerKey.includes('player')) {
          for (let i = playerTimeWindowsEvents.length - 1; i >= 0; i--) {
            const item = playerTimeWindowsEvents[i]
            const payload = item && item.payload
            if ((payload && payload.matchId === matchId)) {
              const currentState = this.state.hasOperationHasReproductionPermission
              const payloadEnabled = payload && payload.enabled

              if (currentState === false && payloadEnabled === true) {
                const groupId = payload &&
                  payload.channels &&
                  payload.channels[0] &&
                  payload.channels[0].iptv &&
                  payload.channels[0].iptv[0] &&
                  payload.channels[0].iptv[0].group_id

                this.setState({ payloadGroupId: groupId ? groupId : null })
              }

              this.setState({ 
                hasSuccessfulPlayerPolling: payload.enabled, 
                hasOperationHasReproductionPermission: payload.enabled
              })
              break
            }
          }
        }

        // Si el partido terminó, detiene el polling
        
        const liveEventMatchStatus = response && response.response && response.response.matchCard && response.response.matchCard[0] && response.response.matchCard[0].status ? response.response.matchCard[0].status : ''
        if (this.isTerminalMatchStatus(liveEventMatchStatus)) {
          // Actualizar estado una última vez antes de detener el polling
          // hasOperationHasReproductionPermission=false para que el live layout se oculte
          if (pollerKey && pollerKey.includes('stats') && response.response) {
            const mappedStats = buildStatsData(response.response);
            const mappedHeaderMatchData = buildHeaderMatchData(response.response);
            this.setState({ matchStatsWithPolling: mappedStats, headerMatchDataWithPolling: mappedHeaderMatchData, hasOperationHasReproductionPermission: false });
          } else {
            this.setState({ hasOperationHasReproductionPermission: false });
          }
          console.log("::::/Termina el polling (finalización del partido)")
          stopped = true
          clearTimeout(timeoutId)
          this.stopAllPollers()
          return
        }

        /* Acciones de score */

        // Normalizar payload: RequestManager puede envolver en response.data
        const payload = (response && response.data) ? response.data : response

        // Detectar fin de partido en payload del poller score (live-events no incluye matchCard)
        if (pollerKey && pollerKey.includes('score')) {
          const payloadStatus = payload && (payload.matchStatus || payload.status)
          if (this.isTerminalMatchStatus(payloadStatus)) {
            console.log("::::/Termina el polling (finalización del partido)")
            stopped = true
            clearTimeout(timeoutId)
            if (pollerKey) delete this.pollers[pollerKey]
            return
          }
        }

        // Actualizar cursor incremental
        if (payload.lastEventId) lastEventId = payload.lastEventId

        const hasMore = !!payload.hasMore
        nextPollMs = Number.isFinite(payload.nextPollMs) && payload.nextPollMs >= 0
          ? payload.nextPollMs
          : defaultDelay
        const delay = hasMore ? 0 : nextPollMs

        /* Acciones de player */

        /* Acciones de stats */
        if (pollerKey && pollerKey.includes('stats') && response.response) {
          const mappedStats = buildStatsData(response.response);
          const mappedHeaderMatchData = buildHeaderMatchData(response.response);
          // Actualizar el estado con los stats y data del header más recientes del polling
          this.setState({ matchStatsWithPolling: mappedStats, headerMatchDataWithPolling: mappedHeaderMatchData });
        }

        /* Acciones de lineups */
        if (pollerKey && pollerKey.includes('lineups') && response.response) {
          const mappedLineups = buildLineupsData(response.response);
          // Actualizar el estado con los lineups
          this.setState({ lineupsWithPolling: mappedLineups });
        }

        // Establece el siguiente polling
        if (stopped) return
        timeoutId = setTimeout(poll, delay)
      } catch (error) {
        if (stopped) return
        timeoutId = setTimeout(poll, defaultDelay)
      }
    }

    poll()

    return () => {
      stopped = true
      clearTimeout(timeoutId)
    }
  }

  
    componentDidUpdate(prevProps, prevState) {
      const { playBackData, matchStats, matchIsPlaying, headerMatchDataWithPolling } = this.state;

      const currentStatus =
        (headerMatchDataWithPolling && headerMatchDataWithPolling.status) ||
        (matchStats && matchStats.matchCard && matchStats.matchCard[0] && matchStats.matchCard[0].status) || '';
      const prevStatus =
        (prevState.headerMatchDataWithPolling && prevState.headerMatchDataWithPolling.status) ||
        (prevState.matchStats && prevState.matchStats.matchCard && prevState.matchStats.matchCard[0] && prevState.matchStats.matchCard[0].status) || '';
      const justBecameCompleted = (currentStatus === 'COMPLETED' || currentStatus === 'FINISHED') && prevStatus !== '' && prevStatus !== currentStatus;
      console.log(':::CDU | currentStatus:', currentStatus, '| prevStatus:', prevStatus, '| justBecameCompleted:', justBecameCompleted, '| matchIsPlaying:', matchIsPlaying, '| showVideoPanel:', this.state.showVideoPanel, '| IPCE:', this.isPlayBackConfigEnable);

      // Manejar transición IN_PROGRESS → COMPLETED/FINISHED
      if (justBecameCompleted) {
        // Ocultar el miniplayer inmediatamente mientras se espera la respuesta del playback.
        // No se puede determinar si hay ventana activa antes de recibir la respuesta.
        if (this.state.showVideoPanel !== false) {
          this.setState({ showVideoPanel: false });
        }

        if (this.isPlayBackConfigEnable) {
          (async () => {
            let newPlayBackData = await getPlayBackData(this.leagueId, this.matchId, this.miniplayerRetryConfig, this.versionPlayBackConfig, this.isPlayBackConfigEnable, this.matchGroupId);
            if (newPlayBackData) newPlayBackData = normalizePlaybackDates(newPlayBackData);
            if (!newPlayBackData) {
              // Sin datos de playback para COMPLETED: no hay ventana activa, ocultar PIP
              this.setState({ playBackData: null, showVideoPanel: false });
            } else {
              // Con datos: el CDU procesará las ventanas y mostrará/ocultará el PIP según corresponda
              this.setState({ playBackData: newPlayBackData });
            }
          })();
        }
        return;
      }

      // Permitir procesamiento de ventanas para COMPLETED (matchIsPlaying=true desde mount)
      if(matchIsPlaying && currentStatus !== 'COMPLETED' && currentStatus !== 'FINISHED') return

      // Procesar alarmas solo si playBackData cambió
      if (playBackData !== prevState.playBackData && playBackData && playBackData.channels !== undefined && this.isPlayBackConfigEnable) {
        const currentDate = Utils.nowWithTimezoneOffset();

        //Filtramos el canal primero si los 2
        const validChannel = playBackData.channels.find(channel =>
        channel.media !== null &&
        channel.events !== null
        );

        // Sin canal con media: canal no contratado → mostrar panel de upsell
        if (!validChannel) {
          const upsellChannel = playBackData.channels.find(ch => !ch.media || ch.media === '');
          if (upsellChannel && !this.state.showUpsellOverlay) {
            this.setState({ showUpsellOverlay: true, selectedChannelForUpsell: upsellChannel });
          } else if (!upsellChannel && this.state.showVideoPanel) {
            this.setState({ showVideoPanel: false });
          }
          return;
        }

        // Clasificar todos los canales con timeWindowStatus
        const classifiedChannel = this.classifyTimeWindows(validChannel, currentDate)
        const classifiedData = { channels: classifiedChannel ? [classifiedChannel] : [] };
        this.classifiedData = classifiedData;

        const vigenteEventObject = this.getFirstVigenteEventObject(classifiedData);
        const futuraEventObject = this.getFirstFuturaEventObject(classifiedData);

        this.vigenteEventObject = vigenteEventObject;
        this.futuraEventObject = futuraEventObject;
        const scheduledAt = this.state && this.state.matchStats && this.state.matchStats.matchCard && this.state.matchStats.matchCard[0] && this.state.matchStats.matchCard[0].summary && this.state.matchStats.matchCard[0].summary.scheduledAt ? this.state.matchStats.matchCard[0].summary.scheduledAt : '';
        const scheduledAtUnix = scheduledAt ? new Date(scheduledAt).getTime() : null;

        console.log("::::/this.vigenteEventObject", this.vigenteEventObject)
        console.log("::::/this.futuraEventObject", this.futuraEventObject)

        // //1.- Buscamos ventanas vigentes con datos correctos de media para mostrar el video panel. Si no hay, buscamos ventanas futuras para configurar alarmas de reproducción
        //   const hasValidMedia = classifiedData && classifiedData.channels && classifiedData.channels.some(channel => channel.media !== null);
        //   const hasVigenteWithValidMedia = classifiedData && classifiedData.channels && classifiedData.channels.some(channel => channel.media !== null && channel.events && channel.events.some(event => event.timeWindowStatus === 'vigente'));
          if (vigenteEventObject) {
            // Si hay una ventana vigente y el usuario tiene derechos de reproducción se muestra pip
            if(vigenteEventObject && (this.enabledPlayBackConfig || this.isPlayBackConfigEnable)){
              // Si el partido ya inició y solo hay play_comments (sin stream en vivo), ocultar PIP
              // Excluir COMPLETED: puede tener ventanas post-partido válidas
              if (this.state.matchIsPlaying && !this.enabledPlayBackConfig && this.isPlayBackConfigEnable && currentStatus !== 'COMPLETED' && currentStatus !== 'FINISHED') {
                if (this.state.showVideoPanel !== false) {
                  this.setState({ showVideoPanel: false });
                }
              } else if (this.state.showVideoPanel !== true) {
                this.setState({ showVideoPanel: true });
              }
            } else if(vigenteEventObject && !this.enabledPlayBackConfig && !this.isPlayBackConfigEnable){
              if (this.state.showVideoPanel !== false) {
                this.setState({ showVideoPanel: false });
              }
            }
          } else {
            // Sin ventana vigente: ocultar el panel de video
            if (this.state.showVideoPanel !== false) {
              this.setState({ showVideoPanel: false });
            }
          }

          if (futuraEventObject) {
            console.log("::::/MELO ENTRO A VENTANAS FUTURAS")
            this.setupReproductionAlarms(futuraEventObject, scheduledAt);  
          }else if(futuraEventObject === null && vigenteEventObject !== null){
            console.log("::::/MELO SOLO HAY VENTANAS VIGENTES")
              const dateEndVigenteUnix = this.vigenteEventObject && this.vigenteEventObject.event 
                  && this.vigenteEventObject.event.dateEnd ? Math.floor(new Date(this.vigenteEventObject.event.dateEnd).getTime() / 1000) : null;

              // Limpiar interval anterior si existe antes de crear uno nuevo
              if (this.intervalHeader) {
                clearInterval(this.intervalHeader);
                this.intervalHeader = null;
              }

              this.intervalHeader = setInterval(() => {   
              let currentDate = Utils.nowWithTimezoneOffset();
                currentDate = Math.floor(currentDate.getTime() / 1000);

                if(currentDate >= dateEndVigenteUnix){                
                  this.setState({ showVideoPanel: false });
                  clearInterval(this.intervalHeader);
                  this.intervalHeader = null;
                }
              }, 1000);
          }

      }
  }

  componentWillUnmount() {
    console.log("::::/Termina el polling")
    this.stopAllPollers()
    this.cleanupReproductionAlarms();
    
    // Limpiar todos los intervals para evitar memory leaks
    if (this.navigationCheckInterval) {
      clearInterval(this.navigationCheckInterval);
      this.navigationCheckInterval = null;
    }
    if (this.intervalMatch) {
      clearInterval(this.intervalMatch);
      this.intervalMatch = null;
    }
    if (this.intervalHeader) {
      clearInterval(this.intervalHeader);
      this.intervalHeader = null;
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  getNodeCode = () => {
    const pathname = window.location.pathname;
    const code = pathname.split('/').filter(Boolean).pop();
    return code;
  }

  getMatchData = () => {
    const { matchData: id } = this.props;
  }

  buildStatsData = () => {
    const { matchStats } = this.state;
    if (!matchStats) return [];
    const stastData = buildStatsData(matchStats);
    return stastData;
  }

  buildPlayersData = () => {
    const { matchStats } = this.state;
    if (!matchStats) return null;

    const playerData = buildPlayersData(matchStats);
    return playerData;
  }

  buildSummaryData = () => {
    const { matchStats } = this.state;
    if (!matchStats) return [];

    const summaryData = buildSummaryData(matchStats);
    return summaryData;
  }

  buildLineupsData = () => {
    const { matchStats } = this.state;
    const apiData = matchStats ? buildLineupsData(matchStats) : null;
    if (apiData != null) return apiData;

    // Fallback: usar lineupsMap del live feed si la API no tiene datos aún
    const liveFeedLineups = this.props.matchData && this.props.matchData.lineups;
    if (liveFeedLineups && liveFeedLineups.homeLineup && liveFeedLineups.awayLineup) {
      var mapLiveStarters = function(starters, side) {
        if (!starters || !starters.length) return [];
        var count = starters.length;
        return starters.map(function(p, i) {
          var x = side === 'home' ? 25 : 75;
          var y = count === 1 ? 50 : Math.round(10 + 80 * i / (count - 1));
          var events = [];
          if (p.playerOut) { events.push('sub_out'); }
          if (p.playerIn) { events.push('sub_in'); }
          var entry = { id: (p.playerId != null && !isNaN(Number(p.playerId))) ? Number(p.playerId) : i, number: p.number || '', name: p.name || '', photoUrl: '', x: x, y: y, events: events, iconUrls: {}, goals: 0 };
          if (p.playerOut && p.subMinute != null) {
            entry.subEvent = {
              minute: p.subMinute,
              name: p.name || '',
              iconUrl: CANCHA_ICONS.subOut,
              minuteColor: '#F44336'
            };
          }
          return entry;
        });
      };
      var mapLiveBench = function(substitutes) {
        return (substitutes || []).map(function(p) {
          var entry = { number: p.number || '', name: p.name || '', goals: 0 };
          if (p.playerIn && p.subMinute != null) {
            entry.subEvent = {
              minute: p.subMinute,
              name: p.name || '',
              iconUrl: CANCHA_ICONS.subIn,
              minuteColor: '#56BC37'
            };
          }
          return entry;
        });
      };
      var homeTeamData = (this.props.matchData && this.props.matchData.homeTeam) || {}
      var awayTeamData = (this.props.matchData && this.props.matchData.awayTeam) || {}
      return {
        homeTeam: {
          name: homeTeamData.name || '', shortName: homeTeamData.shortName || '', flagUrl: homeTeamData.flagUrl || '', teamColor: homeTeamData.teamColor || '',
          formation: liveFeedLineups.homeLineup.formation || '',
          coach: { name: '', photoUrl: '' },
          starters: mapLiveStarters(liveFeedLineups.homeLineup.starters, 'home'),
          bench: mapLiveBench(liveFeedLineups.homeLineup.substitutes)
        },
        awayTeam: {
          name: awayTeamData.name || '', shortName: awayTeamData.shortName || '', flagUrl: awayTeamData.flagUrl || '', teamColor: awayTeamData.teamColor || '',
          formation: liveFeedLineups.awayLineup.formation || '',
          coach: { name: '', photoUrl: '' },
          starters: mapLiveStarters(liveFeedLineups.awayLineup.starters, 'away'),
          bench: mapLiveBench(liveFeedLineups.awayLineup.substitutes)
        }
      };
    }

    // Fallback: datos del live feed ya retornados arriba;
    // si llegamos aquí, apiData es null (matchStats ausente o buildLineupsData retornó null)
    return null;
  }

  buildHeaderMatchData = () => {
    const { matchStats } = this.state;
    if (!matchStats) return null;
    const headerMatchData = buildHeaderMatchData(matchStats);
    return headerMatchData;
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }

  handleClose = () => {
    console.log("::::/Termina el polling")
    this.stopAllPollers()
    this.cleanupReproductionAlarms();

    const pathname = window.location.pathname;
    const getLasFocusItemPartido = pathname.includes("mundial2026") ? localStorage.getItem('lastFocusRecordPartido') : false;
    const getLasFocusItemPais = pathname.includes("mundial2026") ? localStorage.getItem('lastFocusPais') : false;
    if (getLasFocusItemPais && getLasFocusItemPais.includes('pais')) {
      Utils.setInitialFocusChangeTime(getLasFocusItemPais, 500);
    } else if(getLasFocusItemPartido && getLasFocusItemPartido.includes('partido')){
      Utils.setInitialFocusChangeTime(getLasFocusItemPartido, 500);
    }
    
    // Limpiar todos los intervals al cerrar
    if (this.intervalMatch) {
      clearInterval(this.intervalMatch);
      this.intervalMatch = null;
    }
    if (this.intervalHeader) {
      clearInterval(this.intervalHeader);
      this.intervalHeader = null;
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    if (this.navigationCheckInterval) {
      clearInterval(this.navigationCheckInterval);
      this.navigationCheckInterval = null;
    }
    
    const { handleClose } = this.props;
    if (typeof handleClose === 'function') {
      handleClose(null);
    }
  }

  handleShowUpsell = (channel) => {
    // Cuando VideoPanel dispara que un canal no tiene derechos, mostrar UpsellPanel
    this.setState({ 
      showUpsellOverlay: true, 
      selectedChannelForUpsell: channel 
    })
  }

  handleCloseUpsell = () => {
    this.setState({ 
      showUpsellOverlay: false, 
      selectedChannelForUpsell: null 
    })
  }

  sendGA4Metric(matchStats) {
    const gA4 = new GA4();
    const { history } = this.props;
    const constData = {
      event: 'content_play',
      pagePath: window.location.pathname,
      pageTitle: document.title,
      pageUrl: window.location.href,
      currentPath: window.location.pathname,
      modulo_name: matchStats && matchStats.matchCard[0] && matchStats.matchCard[0].groupCode ? matchStats.matchCard[0].groupCode : '',
      content_type:'mundial',
      content_category: 'deportes',
      content_availability: 'por suscripcion',
      provider:'claro video',
      content_location: matchStats && matchStats.matchCard[0] && matchStats.matchCard[0].summary && matchStats.matchCard[0].summary.venue && matchStats.matchCard[0].summary.venue.city ? matchStats.matchCard[0].summary.venue.name +' '+ matchStats.matchCard[0].summary.venue.city : '',
      content_start_date: matchStats && matchStats.matchCard[0] && matchStats.matchCard[0].summary && matchStats.matchCard[0].summary.scheduledAt ? matchStats.matchCard[0].summary.scheduledAt : '',
      match_time: matchStats && matchStats.matchCard[0] && matchStats.matchCard[0].summary && matchStats.matchCard[0].summary.displayTime ? matchStats.matchCard[0].summary.displayTime : '',
      status_card: 'inprogress',
      is_live:'true',
      content_id: this.props && this.props.matchData && this.props.matchData.matchId ? this.props.matchData.matchId : '',
      content_name : this.removeAccents(this.props && this.props.matchData && this.props.matchData.homeTeam && this.props.matchData.homeTeam.name && this.props.matchData.awayTeam && this.props.matchData.awayTeam.name ? this.props.matchData.homeTeam.name + ' vs ' + this.props.matchData.awayTeam.name : '')
    };
  
    const dataMetrics = Utils.getDataContentPlay(history, constData);
    gA4.sendMetricsMundialFase2ContentPlay(dataMetrics);
  }

  removeAccents(str) {
      return str
    .normalize('NFD')                 // separa acentos
    .replace(/[\u0300-\u036f]/g, '') // elimina acentos
    .toLowerCase();  
  }

  /**
   * Valida si el atributo media es un objeto vacío
   * @param {*} media - Atributo media del evento
   * @returns {boolean} true si media es {}, false en caso contrario
   */
  isMediaEmpty = (media) => {
    return media && typeof media === 'object' && Object.keys(media).length === 0;
  };

  getChannelsFromClassifiedData = (classifiedData) => {
    if (!classifiedData || !classifiedData.channels) return [];
    return Array.isArray(classifiedData.channels)
      ? classifiedData.channels
      : [classifiedData.channels];
  }

  getFirstVigenteEventObject = (classifiedData) => {
    const channels = this.getChannelsFromClassifiedData(classifiedData);

    for (let channelIdx = 0; channelIdx < channels.length; channelIdx += 1) {
      const channel = channels[channelIdx];
      if (!channel || !Array.isArray(channel.events)) continue;

      const event = channel.events.find(item => item && item.timeWindowStatus === 'vigente');
      if (event) {
        return {
          channel,
          event,
          channelIdx
        };
      }
    }

    return null;
  }

    getFirstFuturaEventObject = (classifiedData) => {
    const channels = this.getChannelsFromClassifiedData(classifiedData);

    for (let channelIdx = 0; channelIdx < channels.length; channelIdx += 1) {
      const channel = channels[channelIdx];
      if (!channel || !Array.isArray(channel.events)) continue;

      const event = channel.events.find(item => item && item.timeWindowStatus === 'futura');
      if (event) {
        return {
          channel,
          event,
          channelIdx
        };
      }
    }

    return null;
  }

  /**
   * Valida si scheduledAt < dateEnd (primer evento del primer canal)
   * Si se cumple, crea un timer que cuenta hasta dateEnd
   * Cuando dateEnd se alcanza, imprime el mensaje de cierre de upsell
   */
  isScheduledAtBeforeDateEnd = () => {
    if (!this.classifiedData || !this.classifiedData.channels || !this.scheduledAt) return false;

    const scheduledAtUnix = Math.floor(new Date(this.scheduledAt).getTime() / 1000);
    
    // Solo evaluar el primer canal y su primer evento
    const firstChannel = this.classifiedData.channels[0];
    if (!firstChannel || !firstChannel.events || firstChannel.events.length === 0) return false;
    
    const firstEvent = firstChannel.events[0];
    if (!firstEvent.dateEnd) return false;
    
    const dateEndUnix = Math.floor(new Date(firstEvent.dateEnd).getTime() / 1000);
    
    // Validar si  dateEnd < scheduledAt
    if (dateEndUnix < scheduledAtUnix) {
      // Limpiar timer anterior si existe
      if (this.upsellTimerId) {
        clearInterval(this.upsellTimerId);
        this.upsellTimerId = null;
      }
      
      // Crear timer que cuente hasta dateEnd
      this.upsellTimerId = setInterval(() => {
        const currentUnix = Math.floor(Utils.now().getTime() / 1000);
        
        // Cuando se alcanza dateEnd
        if (currentUnix >= dateEndUnix) {
          clearInterval(this.upsellTimerId);
          this.upsellTimerId = null;
          console.log('MELO, se alcanzo dateEnd, cierra upsell');
        }
      }, 1000);
      
      return true;
    }
    
    return false;
  };

  /**
   * Configura alarmas de reproducción para eventos futuros
   * Crea un contador que se decrementa cada segundo
   * Imprime en consola cuando se alcanza dateBegin
   * @param {Object} classifiedData - Datos de reproducción clasificados con timeWindowStatus
   * @param {string} scheduledAt - Fecha y hora programada del evento
   */
  setupReproductionAlarms = (channel, scheduledAt) => {
    this.cleanupReproductionAlarms();
    this.reproductionAlarms = {};

    if (!channel.event) return;

    this.eventKey = `channel_${0}_event_${0}`;

    const dateBegin = new Date(channel.event.dateBegin);
    const currentDate = Utils.nowWithTimezoneOffset();
    const delayMs = Math.max(0, dateBegin.getTime() - currentDate.getTime());

    console.log('TIMER ventana futura: disparará en', Math.floor(delayMs / 1000), 'segundos');

    const triggerPlaybackUpdate = () => {
      this.interval = null;
      delete this.reproductionAlarms[this.eventKey];

      // play_comments solo aplica para SCHEDULED/COMPLETED/FINISHED, no para IN_PROGRESS
      const alarmStatus =
        (this.state.headerMatchDataWithPolling && this.state.headerMatchDataWithPolling.status) ||
        (this.state.matchStats && this.state.matchStats.matchCard && this.state.matchStats.matchCard[0] && this.state.matchStats.matchCard[0].status) || '';
      const alarmIsCommentsCall = this.isPlayBackConfigEnable &&
        (alarmStatus === 'SCHEDULED' || alarmStatus === 'COMPLETED' || alarmStatus === 'FINISHED');
      const alarmPlayCommentsFlag = alarmIsCommentsCall ? this.isPlayBackConfigEnable : false;

      getPlayBackData(
        this.leagueId,
        this.matchId,
        this.miniplayerRetryConfig,
        (this.enabledPlayBackConfig || this.isPlayBackConfigEnable) ? this.versionPlayBackConfig : V1PLAYBACKCONFIG,
        alarmPlayCommentsFlag,
        this.matchGroupId
      ).then((updatedPlayBackData) => {
        // No sobreescribir datos de reproducción activa si el partido ya inició (IN_PROGRESS).
        // Evita condición de carrera donde una respuesta stale (SCHEDULED) llega después de que
        // intervalMatch ya actualizó el estado con datos del stream en vivo.
        const { matchIsPlaying } = this.state;
        const currentStatus =
          (this.state.headerMatchDataWithPolling && this.state.headerMatchDataWithPolling.status) ||
          (this.state.matchStats && this.state.matchStats.matchCard && this.state.matchStats.matchCard[0] && this.state.matchStats.matchCard[0].status) || '';
        if (matchIsPlaying && currentStatus !== 'COMPLETED' && currentStatus !== 'FINISHED') return;

        const normalizedPlayBackData = normalizePlaybackDates(updatedPlayBackData);
        this.setState({ playBackData: normalizedPlayBackData }, () => {
          console.log('PlayBackData actualizado después de alcanzar dateBegin:', normalizedPlayBackData);
        });
      }).catch((error) => {
        console.error('Error al actualizar PlayBackData:', error);
      });
    };

    if (delayMs === 0) {
      triggerPlaybackUpdate();
      return;
    }

    this.interval = setTimeout(triggerPlaybackUpdate, delayMs);

    this.reproductionAlarms[this.eventKey] = {
      interval: this.interval,
      eventId: this.eventKey,
      eventData: channel.event
    };

    this.setState({ reproductionAlarms: this.reproductionAlarms });
  };

  /**
   * Limpia todas las alarmas de reproducción activas
   * Detiene los intervals y limpia el estado
   */
  cleanupReproductionAlarms = () => {
    const { reproductionAlarms } = this.state;
    if (reproductionAlarms && Object.keys(reproductionAlarms).length > 0) {
      Object.values(reproductionAlarms).forEach(alarm => {
        clearInterval(alarm.interval);
      });
    }
    // Limpiar también el timer de upsell
    if (this.upsellTimerId) {
      clearInterval(this.upsellTimerId);
      this.upsellTimerId = null;
    }
    // Limpiar el interval principal usado en setupReproductionAlarms
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.upsellClosedBySchedule = false; // Resetear flag al limpiar alarmas
    this.setState({ reproductionAlarms: {} });
  };

  /**
   * Clasifica las ventanas de tiempo en "vigente" o "futura"
   * @param {Object} channel - Canal individual a clasificar
   * @param {Date} currentDate - Fecha actual para comparación
   * @returns {Object} Canal con eventos clasificados por timeWindowStatus
   */
  classifyTimeWindows = (channel, currentDate) => {
    if (!channel || !channel.events || !Array.isArray(channel.events)) {
      return channel;
    }

    const processedEvents = channel.events.map(event => {
      if (!event.dateBegin || !event.dateEnd) {
        return event;
      }

      // Parsear fechas en formato "YYYY-MM-DD HH:mm:ss"
      const dateBegin = new Date(event.dateBegin);
      const dateEnd = new Date(event.dateEnd);

      console.log('MELO, currentDate:', currentDate);
      console.log('MELO, dateBegin:', dateBegin);
      console.log('MELO, dateEnd:', dateEnd);

      // Clasificar la ventana de tiempo
      let timeWindowStatus = 'pasada'; // Por defecto

      if (currentDate >= dateBegin && currentDate <= dateEnd) {
        timeWindowStatus = 'vigente'; // Fecha actual entre dateBegin y dateEnd
      } else if (currentDate < dateBegin) {
        timeWindowStatus = 'futura'; // Fecha actual menor a dateBegin
      }

      return {
        ...event,
        timeWindowStatus
      };
    });

    return {
      ...channel,
      events: processedEvents
    };
  };

  getSNTarget = (selector) => {
    try {
      return document.querySelector(selector) ? selector : undefined;
    } catch (e) {
      return undefined;
    }
  }

  render() {
    const { activeTab, matchStats, playBackData, hasSuccessfulPlayerPolling, showVideoPanel, payloadGroupId, 
            liveMatchActions, isLoadingActions } = this.state;
    const { matchData = {} } = this.props;
    const { stats, players, summary, lineups, homeTeam, awayTeam, 
            thumbnailUrl, canPlay, upsellPackageName } = matchData;
          
    // Importante tomar en cuenta, esta variable la ocupo con playback v2 con usuario con derechs de reproducción y ventana vigente
    // Si el valor vienen con {} y tienen una ventana futura, cuando se cunpla la alarma, se debe de volver a llamar a la playback v2 
    // Ya se devolverá datos en media y se tiene que mostrar el video,
    const channelMediaV2IsValid = playBackData && playBackData.channels && playBackData.channels.length > 0 && playBackData.channels[0].media && playBackData.channels[0].media && Object.keys(playBackData.channels[0].media).length > 0 ? true : false;
                                                                                                               

    // const headerMatchData = this.buildHeaderMatchData();
    const headerMatchData = this.state.headerMatchDataWithPolling ? this.state.headerMatchDataWithPolling : this.buildHeaderMatchData(); // Se muestra la data del header que viene del polling de 'team-statistics' y si no hay data del polling, se muestra la que viene del llamado inicial con el view 'all'.
    const status = headerMatchData && headerMatchData.status ? headerMatchData.status : '';

    //El usuario puede reproducir
    const userCanPlay =  (playBackData && playBackData.channels && playBackData.channels.length > 0 && playBackData.channels[0].media) && 
                         (playBackData && playBackData.channels && playBackData.channels.length > 0 && playBackData.channels[0].events  && playBackData.channels[0].events.length > 0) ? true : false;

    //Canales disponibles para reproducción
    const channels = playBackData && playBackData.channels ? playBackData.channels : []; 

    // Error de playback: la API devolvió { playback: [], tabs: [] } en lugar de canales
    const isPlayBackError = !!(playBackData &&
      playBackData.channels === undefined &&
      Array.isArray(playBackData.playback) && playBackData.playback.length === 0 &&
      Array.isArray(playBackData.tabs)     && playBackData.tabs.length === 0);

    let shouldShowLiveVideo = false;
    let shouldShowUpsell    = false;

    if (isPlayBackError) {
      // Mostrar el panel de video con el overlay de error, sin generar ningún dispatch
      shouldShowLiveVideo = true;
      shouldShowUpsell    = false;
    } else if (playBackData && playBackData.channels !== undefined) {
      shouldShowLiveVideo = !!(this.state.hasOperationHasReproductionPermission && userCanPlay);
      shouldShowUpsell    = !!(this.state.hasOperationHasReproductionPermission && !userCanPlay);
    } else if (playBackData && playBackData.channels === undefined) {
      shouldShowLiveVideo = true;
      shouldShowUpsell    = false;
    }

    const showOnlyHeader = !userCanPlay && !this.state.hasOperationHasReproductionPermission ? true : false;
    const hasMatchData = !!(headerMatchData && headerMatchData.homeTeam && headerMatchData.homeTeam.name);
    
    // const statsData = this.buildStatsData(); // Cuando se mandaba las Estadísticas obtenias con el view 'all'.
    const statsData = this.state.matchStatsWithPolling ? this.state.matchStatsWithPolling : this.buildStatsData(); // Ahora se muestra la data que viene del polling con el view 'team-statistics' y si no hay data del polling, se muestra la que viene del llamado inicial con el view 'all'.
    const playersData = this.buildPlayersData();
    const summaryData = this.buildSummaryData();
    const lineupsData = this.state.lineupsWithPolling ? this.state.lineupsWithPolling : this.buildLineupsData();

    const inProgressOrMatchIsPlaying = status === 'IN_PROGRESS' || this.state.matchIsPlaying;
    // V2 y V3 se tratan igual: ambos usan ventanas de tiempo y media dinámica
    const isV2orV3 = this.versionPlayBackConfig === V2PLAYBACKCONFIG || this.versionPlayBackConfig === V3PLAYBACKCONFIG;
    const shouldRenderLiveLayoutByPlayback =
      (inProgressOrMatchIsPlaying && !showOnlyHeader && this.versionPlayBackConfig === V1PLAYBACKCONFIG && this.enabledPlayBackConfig) ||
      (inProgressOrMatchIsPlaying && !showOnlyHeader && isV2orV3 && this.enabledPlayBackConfig === true && channelMediaV2IsValid && showVideoPanel) ||
      ((inProgressOrMatchIsPlaying || (status === 'SCHEDULED' && this.isPlayBackConfigEnable)) && !showOnlyHeader && isV2orV3 && this.enabledPlayBackConfig === true && (!channelMediaV2IsValid || showVideoPanel));

    const shouldRenderHeaderGeneralByPlayback = 
      (status === 'IN_PROGRESS' && showOnlyHeader && this.versionPlayBackConfig === V1PLAYBACKCONFIG) ||
      (status === 'IN_PROGRESS' && isV2orV3 && (this.enabledPlayBackConfig === false || this.enabledPlayBackConfig === true) && !showVideoPanel);

    const shouldRenderLiveLayout = shouldRenderLiveLayoutByPlayback || (hasSuccessfulPlayerPolling && shouldRenderHeaderGeneralByPlayback);

    // Evitar render duplicado: no mostrar MatchDetailHeaderGeneral cuando ya se muestra el layout con miniplayer
    const shouldRenderHeaderGeneral = status === 'IN_PROGRESS'
      && !shouldRenderLiveLayout
      && (shouldRenderHeaderGeneralByPlayback
          || (!hasSuccessfulPlayerPolling && !this.state.hasOperationHasReproductionPermission)
          || (!this.enabledPlayBackConfig && !this.isPlayBackConfigEnable));

    // PIP de ventanas de tiempo independiente de broadcast: activo cuando play_comments=true y hay ventana vigente,
    // siempre que el live layout con hasOHRP no ya esté mostrando el PIP.
    const shouldRenderCommentsPanel = this.isPlayBackConfigEnable && showVideoPanel
      && !(shouldRenderLiveLayout && this.state.hasOperationHasReproductionPermission);

    const modalProps = {
      alwaysEnabled: true,
      buttonsAlign: 'vertical',
      aafNewStyle: true,
      className: 'aaf-modal match-detail-modal',
      showLogo: false,
      classNameComponent: 'modal-match-detail',
      callbackWhenBack: this.handleClose,
      onkeyDown: () => {
        window.SpatialNavigation.makeFocusable();
      },
      onkeyUp: () => {
        window.SpatialNavigation.makeFocusable();
      }
    };

    //BORRAR MELO CONSOLA
    // const debugCtime = document.getElementById('debug-ctime');
    // if (debugCtime) debugCtime.innerHTML = "MELO-" + status;

    return (
      <ModalWrapper {...modalProps}>
        <div className="match-detail-content">
          <div className="match-detail-mundial-button">
            <MundialButton
              onClick={this.handleClose}
              id="btnMundialBack"
              className="focusable"
              dataOptions={{
                'data-sn-down': this.getSNTarget(`#match-detail-tab-${activeTab}`),
                'data-sn-left': this.getSNTarget('#mdvp-channel-0'),
                'data-sn-right': this.getSNTarget('#mdvp-channel-0')
              }}
            />
          </div>
          {!status && !hasMatchData ? <MatchDetailHeaderEmpty /> : null}
          {shouldRenderLiveLayout && this.state.hasOperationHasReproductionPermission ? (
            <div className={'match-detail-live-layout' + ((shouldShowUpsell || this.state.showUpsellOverlay) ? ' match-detail-live-layout--upsell' : '')}>
              <div className='match-detail-live-layout__left'>
                {hasMatchData
                  ? <MatchDetailHeader
                      matchData={this.state.matchIsPlaying && headerMatchData && headerMatchData.status === 'SCHEDULED'
                        ? { ...headerMatchData, status: 'IN_PROGRESS' }
                        : headerMatchData}
                      teamColors={headerMatchData.teamColors}
                      isSingleChannel={channels.length === 1}
                      hasPlaybackError={isPlayBackError}
                      isPlayBackConfigEnable={this.isPlayBackConfigEnable}
                    />
                  : <MatchDetailHeaderEmpty />}
              </div>
              {!this.state.showUpsellOverlay && shouldShowLiveVideo ? (
                <div className='match-detail-live-layout__right'>
                  <MatchDetailVideoPanel
                    thumbnailUrl={thumbnailUrl}
                    channels={channels}
                    matchData={this.props.matchData}
                    callback={this.props.callback}
                    pinValidatedGroupId={this.props.pinValidatedGroupId || null}
                    checkPinResponse={this.props.checkPinResponse || null}
                    hasPlaybackError={isPlayBackError}
                    onGroupChange={(groupId) => { this._currentGroupId = groupId }}
                    onShowUpsell={this.handleShowUpsell}
                    onSelectChannel={() => {
                      showSpinner(true);
                      const { callback, pinValidatedGroupId, checkPinResponse } = this.props;
                      const pinOk = pinValidatedGroupId === this._currentGroupId
                        && checkPinResponse && checkPinResponse.data
                        ? true : false;
                      this.handleClose();
                      if (typeof callback === 'function') callback(this._currentGroupId, pinOk || undefined);
                    }}
                    payloadGroupId={payloadGroupId}
                    leagueId={this.leagueId}
                    matchId={this.matchId}
                    miniplayerRetryConfig={this.miniplayerRetryConfig}
                    versionPlayBackConfig={(this.enabledPlayBackConfig || this.isPlayBackConfigEnable) ? this.versionPlayBackConfig : V1PLAYBACKCONFIG}
                    playComments={false}
                  />
                </div>
              ) : this.state.showUpsellOverlay || shouldShowUpsell ? (
                <div className='match-detail-live-layout__right'>
                  <MatchDetailUpsellPanel
                    channels={this.state.selectedChannelForUpsell ? [this.state.selectedChannelForUpsell] : (channels || [])}
                    packageName={upsellPackageName}
                    matchData={this.props.matchData}
                    callback={this.props.callback}
                  />
                </div>
              ) : null}
            </div>
          ) : status === 'FINISHED' || status === 'COMPLETED' ? (
            shouldRenderCommentsPanel || this.state.showUpsellOverlay ? (
              <div className='match-detail-live-layout'>
                <div className='match-detail-live-layout__left'>
                  {hasMatchData
                    ? <MatchDetailHeader matchData={headerMatchData} teamColors={headerMatchData.teamColors} statsData={statsData} liveActions={liveMatchActions} isLoadingActions={isLoadingActions} isPlayBackConfigEnable={this.isPlayBackConfigEnable}/>
                    : <MatchDetailHeaderEmpty />}
                </div>
                <div className='match-detail-live-layout__right'>
                  {this.state.showUpsellOverlay ? (
                    <MatchDetailUpsellPanel
                      channels={this.state.selectedChannelForUpsell ? [this.state.selectedChannelForUpsell] : (channels || [])}
                      packageName={upsellPackageName}
                      matchData={this.props.matchData}
                      callback={this.props.callback}
                    />
                  ) : (
                    <MatchDetailVideoPanel
                      thumbnailUrl={thumbnailUrl}
                      channels={channels}
                      matchData={this.props.matchData}
                      callback={this.props.callback}
                      pinValidatedGroupId={this.props.pinValidatedGroupId || null}
                      checkPinResponse={this.props.checkPinResponse || null}
                      hasPlaybackError={isPlayBackError}
                      onGroupChange={(groupId) => { this._currentGroupId = groupId }}
                      onShowUpsell={this.handleShowUpsell}
                      onSelectChannel={() => {
                        showSpinner(true);
                        const { callback, pinValidatedGroupId, checkPinResponse } = this.props;
                        const pinOk = pinValidatedGroupId === this._currentGroupId
                          && checkPinResponse && checkPinResponse.data
                          ? true : false;
                        this.handleClose();
                        if (typeof callback === 'function') callback(this._currentGroupId, pinOk || undefined);
                      }}
                      payloadGroupId={payloadGroupId}
                      leagueId={this.leagueId}
                      matchId={this.matchId}
                      miniplayerRetryConfig={this.miniplayerRetryConfig}
                      versionPlayBackConfig={(this.enabledPlayBackConfig || this.isPlayBackConfigEnable) ? this.versionPlayBackConfig : V1PLAYBACKCONFIG}
                      playComments={this.isPlayBackConfigEnable}
                    />
                  )}
                </div>
              </div>
            ) : (
              hasMatchData
                ? <MatchDetailHeader matchData={headerMatchData} teamColors={headerMatchData.teamColors} statsData={statsData} liveActions={liveMatchActions} isLoadingActions={isLoadingActions}/>
                : <MatchDetailHeaderEmpty />
            )
          ) : null}
          {shouldRenderHeaderGeneral ? (
            <div className={shouldRenderCommentsPanel ? 'match-detail-live-layout' : ''}>
              <div className={shouldRenderCommentsPanel ? 'match-detail-live-layout__left' : ''}>
                {hasMatchData
                  ? <MatchDetailHeaderGeneral matchData={headerMatchData} teamColors={headerMatchData.teamColors} statsData={statsData} />
                  : <MatchDetailHeaderEmpty />}
              </div>
              {shouldRenderCommentsPanel ? (
                <div className='match-detail-live-layout__right'>
                  <MatchDetailVideoPanel
                    thumbnailUrl={thumbnailUrl}
                    channels={channels}
                    matchData={this.props.matchData}
                    callback={this.props.callback}
                    pinValidatedGroupId={this.props.pinValidatedGroupId || null}
                    checkPinResponse={this.props.checkPinResponse || null}
                    hasPlaybackError={isPlayBackError}
                    onGroupChange={(groupId) => { this._currentGroupId = groupId }}
                    onShowUpsell={this.handleShowUpsell}
                    onSelectChannel={() => {
                      showSpinner(true);
                      const { callback, pinValidatedGroupId, checkPinResponse } = this.props;
                      const pinOk = pinValidatedGroupId === this._currentGroupId
                        && checkPinResponse && checkPinResponse.data
                        ? true : false;
                      this.handleClose();
                      if (typeof callback === 'function') callback(this._currentGroupId, pinOk || undefined);
                    }}
                    payloadGroupId={payloadGroupId}
                    leagueId={this.leagueId}
                    matchId={this.matchId}
                    miniplayerRetryConfig={this.miniplayerRetryConfig}
                    versionPlayBackConfig={(this.enabledPlayBackConfig || this.isPlayBackConfigEnable) ? this.versionPlayBackConfig : V1PLAYBACKCONFIG}
                    playComments={this.isPlayBackConfigEnable}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
          {status === 'SCHEDULED' && !shouldRenderLiveLayout ? (
            <div className={'match-detail-live-layout' + ((shouldShowUpsell || this.state.showUpsellOverlay) ? ' match-detail-live-layout--upsell' : '')}>
              <div className='match-detail-live-layout__left'>
                {hasMatchData
                  ? <MatchDetailHeader matchData={headerMatchData} teamColors={headerMatchData.teamColors} isSingleChannel={channels.length === 1} hasPlaybackError={isPlayBackError} isPlayBackConfigEnable={(shouldRenderCommentsPanel || this.state.showUpsellOverlay) ? this.isPlayBackConfigEnable : false} />
                  : <MatchDetailHeaderEmpty />}
              </div>
              {shouldRenderCommentsPanel || this.state.showUpsellOverlay ? (
                <div className='match-detail-live-layout__right'>
                  {this.state.showUpsellOverlay ? (
                    <MatchDetailUpsellPanel
                      channels={this.state.selectedChannelForUpsell ? [this.state.selectedChannelForUpsell] : (channels || [])}
                      packageName={upsellPackageName}
                      matchData={this.props.matchData}
                      callback={this.props.callback}
                    />
                  ) : (
                    <MatchDetailVideoPanel
                      thumbnailUrl={thumbnailUrl}
                      channels={channels}
                      matchData={this.props.matchData}
                      callback={this.props.callback}
                      pinValidatedGroupId={this.props.pinValidatedGroupId || null}
                      checkPinResponse={this.props.checkPinResponse || null}
                      hasPlaybackError={isPlayBackError}
                      onGroupChange={(groupId) => { this._currentGroupId = groupId }}
                      onShowUpsell={this.handleShowUpsell}
                      onSelectChannel={() => {
                        showSpinner(true);
                        const { callback, pinValidatedGroupId, checkPinResponse } = this.props;
                        const pinOk = pinValidatedGroupId === this._currentGroupId
                          && checkPinResponse && checkPinResponse.data
                          ? true : false;
                        this.handleClose();
                        if (typeof callback === 'function') callback(this._currentGroupId, pinOk || undefined);
                      }}
                      payloadGroupId={payloadGroupId}
                      leagueId={this.leagueId}
                      matchId={this.matchId}
                      miniplayerRetryConfig={this.miniplayerRetryConfig}
                      versionPlayBackConfig={(this.enabledPlayBackConfig || this.isPlayBackConfigEnable) ? this.versionPlayBackConfig : V1PLAYBACKCONFIG}
                      playComments={this.isPlayBackConfigEnable}
                    />
                  )}
                </div>
              ) : null}
            </div>
          ) : null}
          {status !== 'SCHEDULED' && (
            <MatchDetailTabs
              activeTab={activeTab}
              onChange={this.handleTabChange}
              itemDataOptions={{ 'data-sn-up': '#btnMundialBack' }}
            />
          )}
           {status !== 'SCHEDULED' && ( <MatchDetailBody
            activeTabId={`#match-detail-tab-${activeTab}`}
            showCarousel={shouldShowLiveVideo}
            showUpsell={shouldShowUpsell}
          >
            {activeTab === 'stats' && <MatchDetailStats data={statsData} leagueId={this.leagueId} matchId={this.matchId} />}
            {activeTab === 'players' && <MatchDetailPlayers data={playersData} />}
            {activeTab === 'summary' && <MatchDetailSummary 
              data={summaryData} 
              liveMatchActions={liveMatchActions}
              homeTeam={headerMatchData && headerMatchData.homeTeam}
              awayTeam={headerMatchData && headerMatchData.awayTeam}
              leagueId={this.leagueId} 
              matchId={this.matchId}
            />}
            {activeTab === 'lineups' && <MatchDetailLineups lineups={lineupsData} />}
          </MatchDetailBody>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

MatchDetailModal.propTypes = {
  matchData: PropTypes.object,
  handleClose: PropTypes.func,
  callback: PropTypes.func,
};

MatchDetailModal.defaultProps = {
  matchData: {},
  callback: () => {}
};

export default withOnClose(MatchDetailModal);


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailModal/MatchDetailModal.jsx